import NewsletterForm from "./NewsletterForm";

const pillars = [
  {
    icon: "ri-compass-3-line",
    title: "我们是谁",
    text: "劲爆大瓜是一家专注年度与月度话题热榜盘点的内容站，我们把散落各处的热点按热度、反转与影响整理成可快速阅读的榜单。",
  },
  {
    icon: "ri-scales-3-line",
    title: "整理原则",
    text: "只做话题盘点，不做定性与评价；尽量标注热度数据与来源范围，帮助你在“吃瓜”时多一分判断，少一分被带节奏。",
  },
  {
    icon: "ri-eye-off-line",
    title: "内容边界",
    text: "我们侧重事件话题与趋势本身，不虚构事实、不渲染隐私。对于未经证实或来源不明的传闻，不会轻易纳入正式榜单。",
  },
];

const voices = [
  { text: "以前刷到一句标题就划走了，现在按榜单顺序补课，几天的瓜一次就看懂了。", who: "一位追更读者" },
  { text: "评分维度很清楚，哪颗是真爆、哪颗是虚火，看三个指标就明白了。", who: "榜单评论区" },
  { text: "月度榜定期来看，几乎没踩过重复的坑，更新也很稳定。", who: "老粉反馈" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-16 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-bold tracking-widest text-primary-700">
            <i className="ri-information-fill"></i>
            关于榜单
          </span>
          <h2 className="mt-4 font-serif text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            做一份看得懂的热点地图
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们不想制造信息焦虑，而是希望把今年值得知道的瓜料，整理成一份结构清晰的榜单，
            让你想补课时有据可查、看得明白。
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {pillars.map((p) => (
            <div
              key={p.title}
              className="rounded-2xl border border-background-200 bg-background-100 p-6"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-xl text-background-50">
                <i className={p.icon}></i>
              </span>
              <h3 className="mt-4 font-serif text-lg font-bold text-foreground-950">
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {voices.map((v) => (
            <figure
              key={v.who}
              className="rounded-2xl border border-background-200 bg-background-50 p-6"
            >
              <div className="flex gap-0.5 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                “{v.text}”
              </blockquote>
              <figcaption className="mt-3 text-xs text-foreground-500">
                —— {v.who}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>

      {/* 订阅 CTA */}
      <div id="subscribe" className="mx-auto mt-12 w-full max-w-7xl scroll-mt-16 px-4 md:px-6">
        <div className="overflow-hidden rounded-3xl bg-gradient-to-br from-primary-600 via-primary-500 to-accent-500 p-7 md:p-10">
          <div className="max-w-3xl">
            <h3 className="font-serif text-2xl font-black tracking-tight text-background-50 md:text-3xl">
              订阅瓜榜速递 · 每期不错过
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-background-50/90 md:text-base">
              留下邮箱，每期年度榜、月度榜出炉后，我们都会把精华摘要第一时间发给你。
              也欢迎直接邮件我们反馈想上榜却没被收录的热点线索。
            </p>
            <a
              href="mailto:hello@jinbaodagua.example"
              className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-background-50 underline-offset-4 hover:underline"
            >
              <i className="ri-mail-line"></i>
              hello@jinbaodagua.example
            </a>
          </div>
          <NewsletterForm />
        </div>
      </div>
    </section>
  );
}